<template>
  <div class="h-full flex flex-col">
    <div class="flex-1 min-h-0">
      <BaseChart type="donut" :series="series" :extraOptions="extraOptions" />
    </div>

    <div v-if="isClassification" class="mt-2 text-center">
      <div class="text-xs text-gray-400">Índice Geral</div>
      <div class="text-2xl font-bold text-white">
        {{ formatOverallIndex }}
      </div>
      <div
        class="text-sm text-gray-400"
        :class="classificationClass(summary?.overall_classification?.label)"
      >
        {{ summary?.overall_classification?.label || "-" }}
      </div>
    </div>
  </div>
</template>

<script>
import BaseChart from "./BaseChart.vue";

const classificationClass = (key) => {
  if (key === "Favorável") return "text-emerald-400 print:font-bold";
  if (key === "Risco à saúde") return "text-rose-400 print:font-bold";
  return "text-amber-400 print:text-yellow-600 print:font-extrabold";
};

export default {
  name: "DonutYesNoChart",

  components: {
    BaseChart,
  },

  props: {
    // contrato antigo
    yes: {
      type: Number,
      default: null,
    },
    no: {
      type: Number,
      default: null,
    },

    // contrato novo
    segments: {
      type: Array,
      default: () => [],
    },
    variant: {
      type: String,
      default: "binary_donut",
    },
    summary: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      classificationClass,
    };
  },

  computed: {
    isClassification() {
      return this.variant === "classification_donut";
    },

    normalizedSegments() {
      if (this.segments?.length) return this.segments;

      return [
        { label: "Sim", value: this.yes ?? 0 },
        { label: "Não", value: this.no ?? 0 },
      ];
    },

    series() {
      return this.normalizedSegments.map((item) => item.value ?? 0);
    },

    labels() {
      return this.normalizedSegments.map((item) => item.label ?? "");
    },

    formatOverallIndex() {
      const value = this.summary?.overall_index;
      return typeof value === "number"
        ? value.toFixed(2).replace(".", ",")
        : "0,00";
    },

    extraOptions() {
      return {
        labels: this.labels,

        colors: this.isClassification
          ? ["#22c55e", "#f59e0b", "#ef4444"]
          : ["#22c55e", "#ef4444"],

        legend: {
          position: "bottom",
          labels: {
            colors: "#d1d5db",
          },
        },

        stroke: {
          width: 0,
        },

        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: !this.isClassification,
                name: {
                  show: true,
                  color: "#9ca3af",
                },
                value: {
                  show: true,
                  color: "#ffffff",
                  fontSize: "18px",
                  fontWeight: 600,
                  formatter: (val) =>
                    this.isClassification ? `${val}` : `${val}%`,
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#9ca3af",
                  formatter: () =>
                    this.isClassification ? "Questões" : "Geral",
                },
              },
            },
          },
        },

        dataLabels: {
          enabled: false,
        },

        tooltip: {
          theme: "dark",
          y: {
            formatter: (val) =>
              this.isClassification ? `${val} questão(ões)` : `${val}%`,
          },
        },
      };
    },
  },
};
</script>
